import { USER_ROLES } from "../data/constants";
import { DEVICE_IDENTIFIER } from "../data/local-storage-constants";
import store from "../redux/store";
import { getLocalStorage } from "../utils";
import { isSupportLogin } from "./common-helper";

export const isAdminUser = () => {
  const userData = store.getState().businessReducer?.userData;
  return userData?.role === USER_ROLES.admin;
};

export const isUser = () => {
  const userData = store.getState().businessReducer?.userData;
  return userData?.role === USER_ROLES.user;
};

export const getUpdatedUserDetails = () => {
  //default email for support login
  const supportEmail = getLocalStorage(DEVICE_IDENTIFIER) || "";
  const userDetails = store.getState().businessReducer?.userData;
  const { contactInfo: { email = isSupportLogin() ? supportEmail : '', verifiedEmail = isSupportLogin() ? supportEmail : '', name: { firstName = '', lastName = '' } = {} } } = userDetails;
  return {
    email,
    verifiedEmail,
    firstName,
    lastName
  }
}